import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Header() {
  const { user, logout } = useAuth()
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-surface)] px-6 py-3 shadow-sm">
      <div className="flex items-center gap-6">
        <Link to="/dashboard" className="text-lg font-bold text-[var(--color-text)] hover:text-[var(--color-brand-500)]">
          FinApp
        </Link>

        <nav className="flex items-center gap-5 text-sm font-medium text-[var(--color-text-muted)]">
          <Link
            to="/dashboard"
            className={`${isActive('/dashboard') ? 'text-[var(--color-text)]' : 'hover:text-[var(--color-text)]'}`}
          >
            Dashboard
          </Link>
          <Link
            to="/cards"
            className={`${isActive('/cards') ? 'text-[var(--color-text)]' : 'hover:text-[var(--color-text)]'}`}
          >
            Cartões
          </Link>
          <Link
            to="/transactions"
            className={`${isActive('/transactions') ? 'text-[var(--color-text)]' : 'hover:text-[var(--color-text)]'}`}
          >
            Transações
          </Link>
          <Link
            to="/categories"
            className={`${isActive('/categories') ? 'text-[var(--color-text)]' : 'hover:text-[var(--color-text)]'}`}
          >
            Categorias
          </Link>
          {user?.is_admin && (
            <Link
              to="/admin"
              className={`${isActive('/admin') ? 'text-[var(--color-text)]' : 'hover:text-[var(--color-text)]'}`}
            >
              Admin
            </Link>
          )}
        </nav>
      </div>

      <div className="flex items-center gap-4">
        {user ? (
          <div className="flex items-center gap-3">
            <span className="text-sm text-[var(--color-text-muted)]">{user?.full_name ?? user?.email}</span>
            <button
              type="button"
              onClick={logout}
              className="rounded-lg border border-[var(--color-border)] bg-white px-3 py-1.5 text-sm font-medium text-[var(--color-text)] transition-colors hover:bg-[var(--color-surface-subtle)] hover:border-[var(--color-border-strong)]"
            >
              Sair
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="text-sm font-medium text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
            >
              Entrar
            </Link>
            <Link
              to="/register"
              className="rounded-lg bg-[var(--color-brand-500)] px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-[var(--color-brand-600)]"
            >
              Criar conta
            </Link>
          </div>
        )}
      </div>
    </header>
  )
}
